import apiClient from './apiClient';

export const userApi = {
    getAllUsers: () => apiClient.get('/api/users/list').then(res => res.data),
};
